import React from 'react'

const OpenchairIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"

    viewBox="0 0 24 24"
  >
    <path
      clipPath="url(#b)"
      d="M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
    />
  </svg>
)

export default OpenchairIcon



// WEBPACK FOOTER //
// ./src/components/assets/OpenchairIcon.js